import styled from 'styled-components';
import colors from 'constants/colors';

export const Container = styled.div`
  height: 100%;
  justify-content: center;
  text-align: center;

  img {
    margin-top: -20px;
  }

  div {
    text-align: left;
    color: ${colors.white};
    font-size: 22px;
    font-weight: 600;
    margin: 10px 0 20px 30px;
  }
`;
